import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Skills.css';
import aboutEnterprisePlatformImg from '../images/my-skills/about-enterprise-platform.png';
import aboutDesignSystemsImg from '../images/my-skills/about-design-systems.png';
import aboutDesignEngineeringImg from '../images/my-skills/about-design-engineering.png';
import aboutAmbiguityClarityImg from '../images/my-skills/about-ambiguity-clarity.png';
import { getSkills } from '../api/strapi';

const STRAPI_BASE_URL = "http://localhost:1337";

// Interactive Component Playground Component for Development Knowledge
const DevKnowledgeVisual = ({ imgSrc }) => {
  const [activeSpecIndex, setActiveSpecIndex] = useState(1); // Default to Rapid Prototyping
  const [buttonLabel, setButtonLabel] = useState('Submit');
  const [variant, setVariant] = useState('primary');
  const [isMotionTriggered, setIsMotionTriggered] = useState(false);

  // Trigger motion animation when tab is clicked
  const handleSelectTab = (index) => {
    setActiveSpecIndex(index);
    if (index === 1) {
      setIsMotionTriggered(true);
      setTimeout(() => setIsMotionTriggered(false), 2400);
    }
  };

  return (
    <div className="dev-knowledge-container">
      {/* Native Interactive SVG Projection for Development Knowledge */}
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-320 -220 2800 2000" width="100%" height="100%" className="img-fluid skills-reference-graphic" style={{ overflow: 'visible', transition: 'all 0.4s ease' }}>
        <defs>
          <filter id="shadow-clean-panel" x="-30%" y="-30%" width="160%" height="160%">
            <feDropShadow dx="-16" dy="32" stdDeviation="24" floodColor="#0F172A" floodOpacity="0.18" />
          </filter>
          <filter id="shadow-clean-terminal" x="-30%" y="-30%" width="160%" height="160%">
            <feDropShadow dx="-20" dy="40" stdDeviation="28" floodColor="#0F172A" floodOpacity="0.22" />
          </filter>
          <filter id="shadow-hero-prototype" x="-40%" y="-40%" width="180%" height="180%">
            <feDropShadow dx="-32" dy="64" stdDeviation="40" floodColor={variant === 'success' ? '#059669' : '#2563EB'} floodOpacity="0.26" />
          </filter>

          <radialGradient id="pulse-glow-clean" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#38BDF8" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#2563EB" stopOpacity="0" />
          </radialGradient>
        </defs>

        <g transform="translate(1100, 760)">
          <g transform="rotate(-30) skewX(30)">
            {/* Canvas Grid Lines */}
            <path d="M -1100 -500 L 1000 -500 M -1100 0 L 1000 0 M -1100 500 L 1000 500" stroke="#F1F5F9" strokeWidth="3" strokeDasharray="14 14" />
            <path d="M -550 -750 L -550 750 M 0 -750 L 0 750 M 550 -750 L 550 750" stroke="#F1F5F9" strokeWidth="3" strokeDasharray="14 14" />

            {/* ==================== SIDE PANEL: INTERACTIVE ENGINEERING IMPLEMENTATION ==================== */}
            <g transform="translate(-800, -180)" filter="url(#shadow-clean-panel)">
              {/* 3D Extruded Dark Bottom Slab */}
              <polygon points="-240,400 -216,424 264,424 240,400" fill="#020617" stroke="#1E293B" strokeWidth="1" />
              {/* 3D Extruded Dark Right Side Slab */}
              <polygon points="240,-220 264,-196 264,424 240,400" fill="#1E293B" stroke="#334155" strokeWidth="1" />

              <rect x="-240" y="-220" width="480" height="620" rx="20" fill="#0F172A" stroke="#334155" strokeWidth="2.5" />
              
              {/* Panel Header Bar */}
              <path d="M -240 -220 L 240 -220 L 240 -165 L -240 -165 Z" fill="#1E293B" />
              <line x1="-240" y1="-165" x2="240" y2="-165" stroke="#334155" strokeWidth="2" />
              <text x="-210" y="-188" font-family="'Poppins', sans-serif" font-weight="800" font-size="15" fill="#38BDF8" letterSpacing="1">⚙️ ENGINEERING IMPLEMENTATION</text>
              <rect x="110" y="-204" width="110" height="26" rx="13" fill="#064E3B" />
              <text x="165" y="-187" font-family="'Poppins', sans-serif" font-weight="700" font-size="11" fill="#34D399" textAnchor="middle">Production Ready</text>

              {/* CARD 1: Bridging Design & Engineering */}
              <g transform="translate(-210, -135)" onClick={() => handleSelectTab(0)} style={{ cursor: 'pointer' }}>
                <rect x="0" y="0" width="420" height="82" rx="14" fill={activeSpecIndex === 0 ? '#1E293B' : '#0F172A'} stroke={activeSpecIndex === 0 ? '#38BDF8' : '#334155'} strokeWidth={activeSpecIndex === 0 ? '2.5' : '1.5'} />
                <circle cx="24" cy="24" r="14" fill="#0284C7" />
                <text x="24" y="29" font-family="'Poppins', sans-serif" font-weight="800" font-size="13" fill="#FFFFFF" textAnchor="middle">1</text>
                <text x="48" y="24" font-family="'Poppins', sans-serif" font-weight="700" font-size="14" fill="#F8FAFC">Bridging Design &amp; Engineering</text>
                <text x="48" y="52" font-family="'Poppins', sans-serif" font-weight="500" font-size="12" fill="#94A3B8">Translating complex Figma design tokens into production code.</text>
              </g>

              {/* CARD 2: Rapid Functional Prototyping */}
              <g transform="translate(-210, -38)" onClick={() => handleSelectTab(1)} style={{ cursor: 'pointer' }}>
                <rect x="0" y="0" width="420" height="82" rx="14" fill={activeSpecIndex === 1 ? '#1E293B' : '#0F172A'} stroke={activeSpecIndex === 1 ? '#2563EB' : '#334155'} strokeWidth={activeSpecIndex === 1 ? '2.5' : '1.5'} />
                <circle cx="24" cy="24" r="14" fill="#2563EB" />
                <text x="24" y="29" font-family="'Poppins', sans-serif" font-weight="800" font-size="13" fill="#FFFFFF" textAnchor="middle">2</text>
                <text x="48" y="24" font-family="'Poppins', sans-serif" font-weight="700" font-size="14" fill="#F8FAFC">Rapid Functional Prototyping</text>
                <text x="48" y="52" font-family="'Poppins', sans-serif" font-weight="500" font-size="12" fill="#94A3B8">Building high-fidelity, working screens for usability testing.</text>
                {activeSpecIndex === 1 && (
                  <text x="390" y="24" font-family="'Poppins', sans-serif" font-weight="800" font-size="11" fill="#38BDF8" textAnchor="end">▶ LIVE</text>
                )}
              </g>

              {/* CARD 3: Component-Driven Architecture */}
              <g transform="translate(-210, 59)" onClick={() => handleSelectTab(2)} style={{ cursor: 'pointer' }}>
                <rect x="0" y="0" width="420" height="82" rx="14" fill={activeSpecIndex === 2 ? '#1E293B' : '#0F172A'} stroke={activeSpecIndex === 2 ? '#7C3AED' : '#334155'} strokeWidth={activeSpecIndex === 2 ? '2.5' : '1.5'} />
                <circle cx="24" cy="24" r="14" fill="#7C3AED" />
                <text x="24" y="29" font-family="'Poppins', sans-serif" font-weight="800" font-size="13" fill="#FFFFFF" textAnchor="middle">3</text>
                <text x="48" y="24" font-family="'Poppins', sans-serif" font-weight="700" font-size="14" fill="#F8FAFC">Component-Driven Architecture</text>

                {activeSpecIndex === 2 ? (
                  /* Live Interactive Prop Toggles inside Card 3 */
                  <g transform="translate(48, 42)">
                    <g onClick={(e) => { e.stopPropagation(); setButtonLabel(buttonLabel === 'Submit' ? 'Deploy' : 'Submit'); }}>
                      <rect x="0" y="0" width="105" height="24" rx="12" fill="#0F172A" stroke="#38BDF8" strokeWidth="1.5" />
                      <text x="52" y="16" font-family="'Poppins', sans-serif" font-weight="700" font-size="11" fill="#38BDF8" textAnchor="middle">Label: "{buttonLabel}" ⚡</text>
                    </g>
                    <g transform="translate(115, 0)" onClick={(e) => { e.stopPropagation(); setVariant(variant === 'primary' ? 'success' : 'primary'); }}>
                      <rect x="0" y="0" width="115" height="24" rx="12" fill="#0F172A" stroke={variant === 'success' ? '#34D399' : '#3B82F6'} strokeWidth="1.5" />
                      <text x="57" y="16" font-family="'Poppins', sans-serif" font-weight="700" font-size="11" fill={variant === 'success' ? '#34D399' : '#60A5FA'} textAnchor="middle">Variant: {variant} ⚡</text>
                    </g>
                  </g>
                ) : (
                  <text x="48" y="52" font-family="'Poppins', sans-serif" font-weight="500" font-size="12" fill="#94A3B8">Creating scalable, reusable UI components and responsive layouts.</text>
                )}
              </g>

              {/* CARD 4: Technical Collaboration & Version Control */}
              <g transform="translate(-210, 156)" onClick={() => handleSelectTab(3)} style={{ cursor: 'pointer' }}>
                <rect x="0" y="0" width="420" height="82" rx="14" fill={activeSpecIndex === 3 ? '#1E293B' : '#0F172A'} stroke={activeSpecIndex === 3 ? '#059669' : '#334155'} strokeWidth={activeSpecIndex === 3 ? '2.5' : '1.5'} />
                <circle cx="24" cy="24" r="14" fill="#059669" />
                <text x="24" y="29" font-family="'Poppins', sans-serif" font-weight="800" font-size="13" fill="#FFFFFF" textAnchor="middle">4</text>
                <text x="48" y="24" font-family="'Poppins', sans-serif" font-weight="700" font-size="14" fill="#F8FAFC">Technical Collaboration &amp; Git Flow</text>
                <text x="48" y="52" font-family="'Poppins', sans-serif" font-weight="500" font-size="12" fill="#94A3B8">Streamlining team handoff with Git/GitHub version control.</text>
              </g>
            </g>

            {/* ==================== SCREEN 1: CODE TERMINAL (Background Layer - scale 0.92) ==================== */}
            <g transform="translate(-240, 60) scale(0.92)" filter="url(#shadow-clean-terminal)">
              {/* 3D Extruded Dark Bottom Slab */}
              <polygon points="-440,320 -416,344 464,344 440,320" fill="#020617" stroke="#1E293B" strokeWidth="1" />
              {/* 3D Extruded Dark Right Side Slab */}
              <polygon points="440,-320 464,-296 464,344 440,320" fill="#1E293B" stroke="#334155" strokeWidth="1" />

              <rect x="-440" y="-320" width="880" height="640" rx="22" fill="#0F172A" stroke={activeSpecIndex === 0 || activeSpecIndex === 2 ? '#38BDF8' : '#334155'} strokeWidth={activeSpecIndex === 0 || activeSpecIndex === 2 ? '3.5' : '3'} />
              
              <path d="M -440 -320 L 440 -320 L 440 -260 L -440 -260 Z" fill="#1E293B" />
              <line x1="-440" y1="-260" x2="440" y2="-260" stroke="#334155" strokeWidth="2" />
              
              <circle cx="-405" cy="-290" r="7" fill="#FF5F56" />
              <circle cx="-385" cy="-290" r="7" fill="#FFBD2E" />
              <circle cx="-365" cy="-290" r="7" fill="#27C93F" />
              
              <rect x="-330" y="-310" width="165" height="50" rx="10" fill="#0F172A" stroke="#38BDF8" strokeWidth="2" />
              <text x="-298" y="-278" font-family="'Courier New', monospace" font-weight="700" font-size="16" fill="#38BDF8">Button.jsx</text>

              <rect x="-155" y="-310" width="150" height="50" rx="10" fill="#1E293B" />
              <text x="-125" y="-278" font-family="'Courier New', monospace" font-weight="600" font-size="15" fill="#64748B">useAuth.ts</text>

              {/* Syntax Highlighted Code Lines */}
              <g font-family="'Courier New', 'Fira Code', monospace" font-size="17" font-weight="600">
                <text x="-400" y="-205" fill="#64748B">1</text>
                <text x="-350" y="-205" fill="#F43F5E">import</text>
                <text x="-280" y="-205" fill="#F8FAFC">React</text>
                <text x="-220" y="-205" fill="#CBD5E1">,</text>
                <text x="-200" y="-205" fill="#CBD5E1">&#123;</text>
                <text x="-180" y="-205" fill="#38BDF8">useState</text>
                <text x="-95" y="-205" fill="#CBD5E1">&#125;</text>
                <text x="-75" y="-205" fill="#F43F5E">from</text>
                <text x="-25" y="-205" fill="#34D399">'react'</text>
                <text x="55" y="-205" fill="#CBD5E1">;</text>

                <text x="-400" y="-165" fill="#64748B">2</text>
                <text x="-350" y="-165" fill="#F43F5E">import</text>
                <text x="-280" y="-165" fill="#CBD5E1">&#123;</text>
                <text x="-260" y="-165" fill="#38BDF8">motion</text>
                <text x="-190" y="-165" fill="#CBD5E1">&#125;</text>
                <text x="-170" y="-165" fill="#F43F5E">from</text>
                <text x="-120" y="-165" fill="#34D399">'framer-motion'</text>
                <text x="40" y="-165" fill="#CBD5E1">;</text>

                <text x="-400" y="-85" fill="#64748B">4</text>
                <text x="-350" y="-85" fill="#F43F5E">export</text>
                <text x="-280" y="-85" fill="#F43F5E">const</text>
                <text x="-220" y="-85" fill="#38BDF8">Button</text>
                <text x="-150" y="-85" fill="#CBD5E1">=</text>
                <text x="-130" y="-85" fill="#CBD5E1">(&#123;</text>
                <text x="-110" y="-85" fill="#FACC15">label</text>
                <text x="-50" y="-85" fill="#CBD5E1">=</text>
                <text x="-30" y="-85" fill="#34D399">'{buttonLabel}'</text>
                <text x="65" y="-85" fill="#CBD5E1">&#125;)</text>

                <text x="-400" y="-45" fill="#64748B">5</text>
                <text x="-310" y="-45" fill="#F43F5E">const</text>
                <text x="-250" y="-45" fill="#CBD5E1">[</text>
                <text x="-230" y="-45" fill="#F8FAFC">active</text>
                <text x="-160" y="-45" fill="#CBD5E1">,</text>
                <text x="-140" y="-45" fill="#38BDF8">setActive</text>
                <text x="-40" y="-45" fill="#CBD5E1">]</text>
                <text x="-20" y="-45" fill="#CBD5E1">=</text>
                <text x="0" y="-45" fill="#38BDF8">useState</text>
                <text x="85" y="-45" fill="#CBD5E1">(</text>
                <text x="100" y="-45" fill="#F43F5E">false</text>
                <text x="155" y="-45" fill="#CBD5E1">);</text>

                <text x="-400" y="-5" fill="#64748B">6</text>
                <text x="-310" y="-5" fill="#F43F5E">return</text>
                <text x="-240" y="-5" fill="#CBD5E1">(</text>

                <text x="-400" y="35" fill="#64748B">7</text>
                <text x="-280" y="35" fill="#CBD5E1">&lt;</text>
                <text x="-265" y="35" fill="#F43F5E">motion.button</text>

                <text x="-400" y="75" fill="#64748B">8</text>
                <text x="-240" y="75" fill="#FACC15">whileHover</text>
                <text x="-130" y="75" fill="#CBD5E1">=</text>
                <text x="-110" y="75" fill="#CBD5E1">&#123;&#123;</text>
                <text x="-80" y="75" fill="#FACC15">scale</text>
                <text x="-20" y="75" fill="#CBD5E1">:</text>
                <text x="0" y="75" fill="#34D399">1.05</text>
                <text x="50" y="75" fill="#CBD5E1">&#125;&#125;</text>

                <text x="-400" y="115" fill="#64748B">9</text>
                <text x="-240" y="115" fill="#FACC15">className</text>
                <text x="-140" y="115" fill="#CBD5E1">=</text>
                <text x="-120" y="115" fill="#34D399">"btn btn-{variant}"</text>

                <text x="-400" y="155" fill="#64748B">10</text>
                <text x="-240" y="155" fill="#FACC15">onClick</text>
                <text x="-160" y="155" fill="#CBD5E1">=</text>
                <text x="-140" y="155" fill="#CBD5E1">&#123;()</text>
                <text x="-100" y="155" fill="#F43F5E">=&gt;</text>
                <text x="-70" y="155" fill="#38BDF8">setActive</text>(true)<text x="30" y="155" fill="#CBD5E1">&#125;</text>
                <text x="50" y="155" fill="#CBD5E1">&gt;</text>

                <text x="-400" y="195" fill="#64748B">11</text>
                <text x="-200" y="195" fill="#CBD5E1">&#123;</text>
                <text x="-180" y="195" fill="#F8FAFC">"{buttonLabel}"</text>
                <text x="-125" y="195" fill="#CBD5E1">&#125;</text>

                <text x="-400" y="235" fill="#64748B">12</text>
                <text x="-280" y="235" fill="#CBD5E1">&lt;/</text>
                <text x="-255" y="235" fill="#F43F5E">motion.button</text>
                <text x="-110" y="235" fill="#CBD5E1">&gt;</text>
              </g>

              {/* Dynamic Code Highlight Overlay Box depending on activeSpecIndex */}
              {activeSpecIndex === 0 && (
                <rect x="-415" y="-220" width="560" height="75" rx="8" fill="#38BDF8" fillOpacity="0.12" stroke="#38BDF8" strokeWidth="1.5" strokeDasharray="6 6" />
              )}
              {activeSpecIndex === 2 && (
                <rect x="-415" y="-105" width="620" height="360" rx="12" fill="#7C3AED" fillOpacity="0.12" stroke="#7C3AED" strokeWidth="1.5" strokeDasharray="6 6" />
              )}
              {activeSpecIndex === 3 && (
                <g transform="translate(100, 200)">
                  <rect x="0" y="0" width="310" height="40" rx="8" fill="#064E3B" stroke="#34D399" strokeWidth="1.5" />
                  <text x="155" y="25" font-family="'Poppins', sans-serif" font-weight="700" font-size="12" fill="#34D399" textAnchor="middle">✓ Git Handoff: PR #142 Merged</text>
                </g>
              )}
            </g>

            {/* ==================== SCREEN 2: HERO-SIZED HIGH-FIDELITY PROTOTYPE (Upper Focal Layer - scale 1.22) ==================== */}
            <g transform="translate(460, -220) scale(1.22)" filter="url(#shadow-hero-prototype)">
              {/* 3D Extruded White Bottom Slab */}
              <polygon points="-440,350 -414,376 526,376 500,350" fill="#CBD5E1" stroke="#94A3B8" strokeWidth="1.5" />
              {/* 3D Extruded White Right Side Slab */}
              <polygon points="500,-300 526,-274 526,376 500,350" fill="#E2E8F0" stroke="#CBD5E1" strokeWidth="1.5" />

              {/* Main Window Surface Container */}
              <rect x="-440" y="-300" width="940" height="650" rx="26" fill="#FFFFFF" stroke={activeSpecIndex === 1 ? '#3B82F6' : variant === 'success' ? '#059669' : '#2563EB'} strokeWidth={activeSpecIndex === 1 ? '4' : '3.5'} />
              
              {/* Header Address & App Bar */}
              <path d="M -440 -300 L 500 -300 L 500 -230 L -440 -230 Z" fill="#F8FAFC" />
              <line x1="-440" y1="-230" x2="500" y2="-230" stroke="#E2E8F0" strokeWidth="1.5" />
              
              {/* Traffic Dots */}
              <circle cx="-405" cy="-265" r="7" fill="#FF5F56" />
              <circle cx="-385" cy="-265" r="7" fill="#FFBD2E" />
              <circle cx="-365" cy="-265" r="7" fill="#27C93F" />
              
              {/* URL Bar */}
              <rect x="-330" y="-280" width="530" height="32" rx="16" fill="#FFFFFF" stroke="#CBD5E1" strokeWidth="1.5" />
              <text x="-310" y="-259" font-family="'Poppins', sans-serif" font-weight="600" font-size="13" fill="#64748B">🔒 https://app.designsystem.io/checkout/prototype-flow</text>
              
              {/* Prototype Tag */}
              <rect x="230" y="-280" width="240" height="32" rx="16" fill="#EFF6FF" stroke="#3B82F6" strokeWidth="1.5" />
              <circle cx="250" cy="-264" r="5" fill="#2563EB" />
              <text x="265" y="-259" font-family="'Poppins', sans-serif" font-weight="700" font-size="12" fill="#1D4ED8">HERO PROTOTYPE • 60 FPS</text>

              {/* PROTOTYPE BODY CONTENT */}
              <g transform="translate(0, 10)">
                <g transform="translate(-400, -200)">
                  <text x="0" y="0" font-family="'Poppins', sans-serif" font-weight="800" font-size="18" fill="#0F172A">⚡ ACME SYSTEM</text>
                  <text x="180" y="-1" font-family="'Poppins', sans-serif" font-weight="600" font-size="13" fill="#64748B">Checkout &gt; Review &amp; Pay</text>
                  
                  <rect x="750" y="-16" width="110" height="28" rx="14" fill="#F1F5F9" stroke="#E2E8F0" strokeWidth="1.5" />
                  <circle cx="768" cy="-2" r="9" fill="#2563EB" />
                  <text x="768" y="2" font-family="'Poppins', sans-serif" font-weight="800" font-size="10" fill="#FFFFFF" textAnchor="middle">JD</text>
                  <text x="806" y="2" font-family="'Poppins', sans-serif" font-weight="700" font-size="11" fill="#334155">🛒 (3)</text>
                </g>

                <line x1="-400" y1="-175" x2="460" y2="-175" stroke="#E2E8F0" strokeWidth="1.5" />

                <text x="-400" y="-140" font-family="'Poppins', sans-serif" font-weight="800" font-size="22" fill="#0F172A">Enterprise Checkout Flow</text>
                <text x="-400" y="-115" font-family="'Poppins', sans-serif" font-weight="500" font-size="13" fill="#64748B">Step 3 of 3 • Review &amp; Confirm Order</text>

                {/* LEFT COLUMN: ORDER SUMMARY CARD */}
                <g transform="translate(-400, -90)">
                  <rect x="0" y="0" width="410" height="255" rx="16" fill="#F8FAFC" stroke="#E2E8F0" strokeWidth="1.5" />
                  <text x="20" y="32" font-family="'Poppins', sans-serif" font-weight="700" font-size="14" fill="#1E293B">📦 ORDER SUMMARY (2 ITEMS)</text>

                  <g transform="translate(20, 50)">
                    <rect x="0" y="0" width="36" height="36" rx="8" fill="#DBEAFE" />
                    <text x="18" y="23" font-family="'Poppins', sans-serif" font-weight="800" font-size="15" fill="#1E40AF" textAnchor="middle">DS</text>
                    <text x="48" y="16" font-family="'Poppins', sans-serif" font-weight="700" font-size="13" fill="#0F172A">Enterprise Design Tokens</text>
                    <text x="48" y="32" font-family="'Poppins', sans-serif" font-weight="500" font-size="11" fill="#64748B">Framer + Figma UI System</text>
                    <text x="370" y="24" font-family="'Poppins', sans-serif" font-weight="800" font-size="13" fill="#0F172A" textAnchor="end">$99.00</text>
                  </g>

                  <line x1="20" y1="100" x2="390" y2="100" stroke="#E2E8F0" strokeWidth="1" />

                  <g transform="translate(20, 110)">
                    <rect x="0" y="0" width="36" height="36" rx="8" fill="#EDE9FE" />
                    <text x="18" y="23" font-family="'Poppins', sans-serif" font-weight="800" font-size="15" fill="#6D28D9" textAnchor="middle">JS</text>
                    <text x="48" y="16" font-family="'Poppins', sans-serif" font-weight="700" font-size="13" fill="#0F172A">React Component Pro Kit</text>
                    <text x="48" y="32" font-family="'Poppins', sans-serif" font-weight="500" font-size="11" fill="#64748B">TypeScript • Accessible ARIA</text>
                    <text x="370" y="24" font-family="'Poppins', sans-serif" font-weight="800" font-size="13" fill="#0F172A" textAnchor="end">$50.00</text>
                  </g>

                  <line x1="20" y1="160" x2="390" y2="160" stroke="#CBD5E1" strokeWidth="1.5" strokeDasharray="4 4" />

                  <g transform="translate(20, 180)">
                    <text x="0" y="14" font-family="'Poppins', sans-serif" font-weight="500" font-size="12" fill="#64748B">Subtotal</text>
                    <text x="370" y="14" font-family="'Poppins', sans-serif" font-weight="600" font-size="12" fill="#334155" textAnchor="end">$149.00</text>
                    <text x="0" y="34" font-family="'Poppins', sans-serif" font-weight="500" font-size="12" fill="#64748B">Express Instant Delivery</text>
                    <text x="370" y="34" font-family="'Poppins', sans-serif" font-weight="700" font-size="12" fill="#059669" textAnchor="end">FREE</text>
                    <text x="0" y="58" font-family="'Poppins', sans-serif" font-weight="800" font-size="15" fill="#0F172A">Total Due</text>
                    <text x="370" y="58" font-family="'Poppins', sans-serif" font-weight="800" font-size="17" fill="#2563EB" textAnchor="end">$149.00</text>
                  </g>
                </g>

                {/* RIGHT COLUMN: PAYMENT & ACTION BUTTONS CARD */}
                <g transform="translate(30, -90)">
                  <rect x="0" y="0" width="430" height="155" rx="16" fill="#F8FAFC" stroke="#E2E8F0" strokeWidth="1.5" />
                  <text x="20" y="30" font-family="'Poppins', sans-serif" font-weight="700" font-size="14" fill="#1E293B">💳 PAYMENT METHOD</text>

                  <g transform="translate(20, 44)">
                    <rect x="0" y="0" width="390" height="44" rx="10" fill="#EFF6FF" stroke="#3B82F6" strokeWidth="2" />
                    <circle cx="22" cy="22" r="7" fill="#2563EB" />
                    <circle cx="22" cy="22" r="3" fill="#FFFFFF" />
                    <text x="40" y="27" font-family="'Poppins', sans-serif" font-weight="700" font-size="13" fill="#1E40AF">Credit Card •••• 4242 (Visa)</text>
                    <rect x="310" y="11" width="65" height="22" rx="11" fill="#DBEAFE" />
                    <text x="342" y="26" font-family="'Poppins', sans-serif" font-weight="700" font-size="10" fill="#1D4ED8" textAnchor="middle">DEFAULT</text>
                  </g>

                  <g transform="translate(20, 96)">
                    <rect x="0" y="0" width="390" height="42" rx="10" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="1.5" />
                    <circle cx="22" cy="21" r="7" fill="#FFFFFF" stroke="#94A3B8" strokeWidth="1.5" />
                    <text x="40" y="26" font-family="'Poppins', sans-serif" font-weight="600" font-size="13" fill="#475569">Apple Pay </text>
                  </g>

                  <g transform="translate(0, 180)">
                    <g transform="translate(0, 0)">
                      {(isMotionTriggered || activeSpecIndex === 1) && (
                        <circle cx="105" cy="26" r="30" fill="url(#pulse-glow-clean)" className="click-pulse" />
                      )}

                      {/* Single Clean Primary Button Surface */}
                      <rect x="0" y="0" width="210" height="54" rx="27" fill={variant === 'success' ? '#059669' : '#2563EB'} stroke="#FFFFFF" strokeWidth="2.5" />
                      <text x="105" y="33" font-family="'Poppins', sans-serif" font-weight="700" font-size="17" fill="#FFFFFF" textAnchor="middle">{buttonLabel}</text>

                      <g transform="translate(160, 28) rotate(-15)">
                        <path d="M1 1V20.5L6.5 15L11.5 25L14.5 23.5L9.5 14L17.5 14L1 1Z" fill="#0F172A" stroke="#FFFFFF" strokeWidth="2" />
                      </g>
                    </g>

                    <g transform="translate(230, 0)">
                      <rect x="0" y="0" width="145" height="54" rx="27" fill="#F8FAFC" stroke="#94A3B8" strokeWidth="2" />
                      <text x="72" y="33" font-family="'Poppins', sans-serif" font-weight="700" font-size="15" fill="#475569" textAnchor="middle">Cancel</text>
                    </g>
                  </g>
                </g>

                {/* LIVE SUCCESS SPRING NOTIFICATION BADGE */}
                <g transform="translate(-160, 185)">
                  <path d="M 0 -30 C 80 -30, 120 10, 160 30" stroke={variant === 'success' ? '#059669' : '#2563EB'} strokeWidth="3" strokeDasharray="6 6" fill="none" />
                  <polygon points="158,16 170,32 150,34" fill={variant === 'success' ? '#059669' : '#2563EB'} />

                  <rect x="-100" y="30" width="370" height="92" rx="18" fill="#F0FDF4" stroke="#16A34A" strokeWidth="2.5" />
                  <circle cx="-60" cy="76" r="22" fill="#DCFCE7" />
                  <text x="-60" y="83" font-family="'Poppins', sans-serif" font-weight="800" font-size="20" fill="#15803D" textAnchor="middle">✓</text>
                  <text x="-20" y="67" font-family="'Poppins', sans-serif" font-weight="700" font-size="16" fill="#14532D">Order Confirmed!</text>
                  <text x="-20" y="91" font-family="'Poppins', sans-serif" font-weight="500" font-size="13" fill="#166534">Transition: Spring 300ms • Ease-Out</text>
                </g>
              </g>
            </g>

            {/* DYNAMIC ANNOTATION VECTOR POINTER LINE DEPENDING ON ACTIVE SPEC INDEX */}
            <g stroke={activeSpecIndex === 0 ? '#38BDF8' : activeSpecIndex === 1 ? '#2563EB' : activeSpecIndex === 2 ? '#7C3AED' : '#059669'} strokeWidth="3" strokeDasharray="6 6" fill="none">
              {activeSpecIndex === 0 && (
                <path d="M -560 -90 C -480 -90, -420 -160, -360 -160" />
              )}
              {activeSpecIndex === 1 && (
                <path d="M -560 0 C -280 0, 220 -40, 340 -40" />
              )}
              {activeSpecIndex === 2 && (
                <path d="M -560 100 C -450 100, -400 50, -320 50" />
              )}
              {activeSpecIndex === 3 && (
                <path d="M -560 200 C -400 200, -300 240, -100 240" />
              )}
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

// Interactive Enterprise Design System Component for Design Expertise
const EnterpriseDesignSystemVisual = ({ imgSrc }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [activeSpecIndex, setActiveSpecIndex] = useState(1);

  const cssSpecs = [
    {
      title: "Display & Type Tokens",
      tag: "TYPOGRAPHY",
      code: `font-family: 'Poppins', sans-serif;\nfont-size: 28px; font-weight: 800;\nline-height: 1.2;\ncolor: ${isDarkMode ? '#F8FAFC' : '#0F172A'};`
    },
    {
      title: "User Accounts Table",
      tag: "CARD STOCK",
      code: `background: ${isDarkMode ? '#0F172A' : '#FFFFFF'};\nborder: 3px solid ${isDarkMode ? '#334155' : '#E2E8F0'};\nborder-radius: 24px;\nbox-shadow: 0 24px 56px rgba(0,0,0,${isDarkMode ? '0.45' : '0.14'});`
    },
    {
      title: "Color Swatches & Icons",
      tag: "BRAND TOKENS",
      code: `/* Brand Token: Primary 600 */\ncolor: ${isDarkMode ? '#38BDF8' : '#2563EB'};\nbackground: ${isDarkMode ? '#0F172A' : '#EFF6FF'};\nborder-radius: 10px;\nicon-size: 20px;`
    },
    {
      title: "Status Badges & Grid",
      tag: "BADGE TOKENS",
      code: `font-size: 13px; font-weight: 700;\npadding: 8px 18px;\nborder-radius: 18px;\nbackground: ${isDarkMode ? '#064E3B' : '#DCFCE7'};\ncolor: ${isDarkMode ? '#34D399' : '#15803D'};\ngrid-gap: 16px;`
    },
    {
      title: "Data Rows & Content",
      tag: "DATA ROW",
      code: `display: flex; align-items: center;\ngrid-gap: 24px; padding: 16px 24px;\nbackground: ${isDarkMode ? '#1E293B' : '#FFFFFF'};\nborder-radius: 12px;\nbox-shadow: 0 12px 28px rgba(0,0,0,0.08);`
    }
  ];

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    // Precision 2D Hover Regions aligned to Y-Axis Flipped Isometric Layout
    if (x < 0.50 && y < 0.45) {
      setActiveSpecIndex(0); // Typography Tokens (Top-Left)
    } else if (x > 0.52 && y < 0.50) {
      setActiveSpecIndex(2); // Color Swatches & Icons (Top-Right)
    } else if (x >= 0.22 && x <= 0.78 && y >= 0.30 && y <= 0.78) {
      setActiveSpecIndex(1); // User Accounts Table (Center)
    } else if (x < 0.42 && y > 0.60) {
      setActiveSpecIndex(3); // Status Badges & Grid (Bottom-Left)
    } else {
      setActiveSpecIndex(4); // Data Rows & Content (Bottom-Right)
    }
  };

  const currentSpec = cssSpecs[activeSpecIndex];

  return (
    <div
      className="design-system-container"
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Light Mode / Dark Mode Toggle Controls */}
      <div className="ds-mode-controls">
        <span className="ds-control-label">Design Library:</span>
        <div className="ds-mode-toggle-group">
          <button
            className={`ds-mode-btn ${!isDarkMode ? 'active-mode' : ''}`}
            onClick={() => setIsDarkMode(false)}
          >
            ☀️ Light Mode
          </button>
          <button
            className={`ds-mode-btn ${isDarkMode ? 'active-dark' : ''}`}
            onClick={() => setIsDarkMode(true)}
          >
            🌙 Dark Mode
          </button>
        </div>
      </div>

      {/* DevTools CSS Specs Inspector Card */}
      {isHovered && (
        <div className={`figma-css-inspector-card ${isDarkMode ? 'inspector-dark' : 'inspector-light'}`}>
          <div className="css-inspector-header">
            <span className="css-inspector-title">⚡ {currentSpec.title}</span>
            <span className="css-inspector-tag">{currentSpec.tag}</span>
          </div>
          <pre className="css-inspector-code">
            {currentSpec.code.split('\n').map((line, i) => {
              const parts = line.split(':');
              if (parts.length === 2) {
                return (
                  <div key={i}>
                    <span className="css-prop">{parts[0]}</span>
                    <span className="css-punct">:</span>
                    <span className="css-val">{parts[1]}</span>
                  </div>
                );
              }
              return <div key={i} className="css-punct">{line}</div>;
            })}
          </pre>
        </div>
      )}

      {/* Updated Design Expertise SVG Graphic */}
      <img
        src={imgSrc || ""}
        alt="Design Expertise Graphic"
        className={`img-fluid skills-reference-graphic ${isDarkMode ? 'mode-dark' : 'mode-light'}`}
        style={{ transition: 'all 0.4s ease' }}
      />
    </div>
  );
};

// Interactive Figma Multiplayer Cursors Component for Collaboration & Leadership
const FigmaCollabVisual = ({ imgSrc }) => {
  const [mousePos, setMousePos] = useState({ x: 55, y: 45 });
  const [isHovered, setIsHovered] = useState(false);
  const containerRef = React.useRef(null);

  const handleMouseMove = (e) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setMousePos({
      x: Math.max(5, Math.min(95, x)),
      y: Math.max(5, Math.min(95, y))
    });
  };

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  // Collaborator cursors data with name badges and relative offsets
  const collaborators = [
    {
      id: 'you',
      name: 'Michelle (Lead UX)',
      color: '#2563EB', // Blue
      defaultPos: { x: 55, y: 38 },
      offset: { x: 0, y: 0 }
    },
    {
      id: 'pm',
      name: 'Alex (Product Manager)',
      color: '#EA580C', // Orange
      defaultPos: { x: 30, y: 62 },
      offset: { x: -14, y: 10 }
    },
    {
      id: 'dev',
      name: 'Sarah (Lead Engineer)',
      color: '#059669', // Emerald Green
      defaultPos: { x: 74, y: 46 },
      offset: { x: 16, y: -8 }
    },
    {
      id: 'ds',
      name: 'David (Design Systems)',
      color: '#7C3AED', // Purple
      defaultPos: { x: 42, y: 22 },
      offset: { x: -10, y: -16 }
    }
  ];

  return (
    <div
      ref={containerRef}
      className="figma-collab-container"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img
        src={imgSrc}
        alt="Collaboration & Leadership Graphic"
        className="img-fluid skills-reference-graphic"
      />

      {/* Interactive Figma Multiplayer Cursors */}
      {collaborators.map((c) => {
        const posX = isHovered ? Math.max(5, Math.min(92, mousePos.x + c.offset.x)) : c.defaultPos.x;
        const posY = isHovered ? Math.max(5, Math.min(92, mousePos.y + c.offset.y)) : c.defaultPos.y;

        return (
          <div
            key={c.id}
            className={`figma-cursor-wrapper ${isHovered ? 'active-hover' : 'ambient-float'}`}
            style={{
              left: `${posX}%`,
              top: `${posY}%`,
              transition: isHovered
                ? 'left 0.22s cubic-bezier(0.25, 1, 0.5, 1), top 0.22s cubic-bezier(0.25, 1, 0.5, 1)'
                : 'left 0.8s ease, top 0.8s ease'
            }}
          >
            {/* SVG Pointer Arrow */}
            <svg width="24" height="24" viewBox="0 0 26 26" fill="none" className="figma-cursor-icon">
              <path
                d="M 4.5 3.5 C 3.5 2.7 2.4 3.8 3.2 4.8 L 9.8 24.2 C 10.3 25.4 11.9 25.3 12.3 24.0 L 15.1 15.1 L 24.0 12.3 C 25.3 11.9 25.4 10.3 24.2 9.8 L 4.8 3.2 C 4.6 3.1 4.4 3.1 4.5 3.5 Z"
                fill={c.color}
                stroke="#FFFFFF"
                strokeWidth="2"
                strokeLinejoin="round"
                strokeLinecap="round"
              />
            </svg>

            {/* Name & Role Pill Badge */}
            <div className="figma-cursor-badge" style={{ backgroundColor: c.color }}>
              {c.name}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const defaultSkillsData = [
  {
    id: 1,
    order: 1,
    title: "Design Expertise",
    icon: "clipboard-pencil",
    summary: "I specialize in user-centered design, creating intuitive and engaging experiences that prioritize user needs.",
    skills: [
      {
        title: "Design Systems",
        description: "Building and scaling multi-brand systems to reduce design-to-dev friction across ecosystems with millions of users."
      },
      {
        title: "Interaction Design",
        description: "Translating complex workflows into intuitive, secure identity flows and logistics dashboards."
      },
      {
        title: "Product Design",
        description: "Owning end-to-end product vision from initial user insight to production-ready specifications."
      },
      {
        title: "Data Visualization",
        description: "Mapping high-stakes transportation and logistics data into actionable enterprise interfaces."
      }
    ]
  },
  {
    id: 2,
    order: 2,
    title: "Development Knowledge",
    icon: "code-laptop",
    summary: "I specialize in front-end development with expertise in HTML5, CSS3, JavaScript, and responsive design using modern frameworks like React.js.",
    skills: [
      {
        title: "Bridging Design & Engineering",
        description: "Leveraging a deep proficiency in React.js, JavaScript, and CSS/SCSS to translate complex design visions into production-ready front-end code."
      },
      {
        title: "Rapid Functional Prototyping",
        description: "Accelerating the product cycle by building high-fidelity, working screens that allow for authentic usability testing and faster stakeholder validation."
      },
      {
        title: "Component-Driven Architecture",
        description: "Specialized in creating scalable, reusable UI components and responsive layouts that maintain system integrity across diverse enterprise platforms."
      },
      {
        title: "Technical Collaboration & Version Control",
        description: "Streamlining the handoff process through expert use of Git/GitHub and effective cross-functional communication with engineering teams."
      }
    ]
  },
  {
    id: 3,
    order: 3,
    title: "Collaboration & Leadership",
    icon: "users-leadership",
    summary: "I excel in cross-functional collaboration, facilitating seamless design-to-development handoffs and aligning teams around shared goals.",
    skills: [
      {
        title: "Cross-Functional Alignment",
        description: "Championing a unified product vision by aligning engineering, product, and stakeholders around shared goals and user-centered outcomes."
      },
      {
        title: "Design Operations & Handoff",
        description: "Reducing design-to-dev friction through structured handoff processes and production-ready UI specifications that support seamless implementation."
      },
      {
        title: "Facilitating Innovation",
        description: "Leading design sprints and collaborative workshops to foster rapid ideation, iterative problem-solving, and creative breakthroughs in dynamic environments."
      },
      {
        title: "Evidence-Based Leadership",
        description: "Steering product direction through rigorous usability testing and research, ensuring design decisions are backed by data and validated user needs."
      }
    ]
  }
];

function renderSkillCategoryIcon(icon, title) {
  const t = (title || '').toLowerCase();
  const i = (icon || '').toLowerCase();

  if (t.includes('design') || i.includes('design') || i.includes('clipboard') || i.includes('pencil')) {
    return (
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="me-2 flex-shrink-0">
        <rect x="5" y="4" width="14" height="17" rx="2" ry="2"></rect>
        <path d="M9 2h6v4H9z"></path>
        <path d="M9 12h6"></path>
        <path d="M9 16h4"></path>
        <path d="M14 9l3-3"></path>
      </svg>
    );
  }

  if (t.includes('dev') || t.includes('code') || i.includes('code') || i.includes('laptop')) {
    return (
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="me-2 flex-shrink-0">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
        <polyline points="7 8 10 10 7 12"></polyline>
        <line x1="13" y1="12" x2="16" y2="12"></line>
      </svg>
    );
  }

  return (
    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="me-2 flex-shrink-0">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  );
}

function Skills() {
  const [skillsList, setSkillsList] = useState(defaultSkillsData);

  useEffect(() => {
    getSkills()
      .then((data) => {
        if (data && data.length > 0) {
          const formatted = data.map((item) => ({
            id: item.id,
            order: item.order || 1,
            title: item.title,
            icon: item.icon || 'clipboard-pencil',
            summary: item.summary || '',
            skills: item.skills || [],
            media: item.media ? `${STRAPI_BASE_URL}${item.media.url}` : null
          }));
          setSkillsList(formatted);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch skills from Strapi, using default fallbacks:", err);
      });
  }, []);

  const renderVisual = (index, mediaUrl) => {
    if (mediaUrl) {
      return <img src={mediaUrl} alt="Skill Visual" className="img-fluid skills-reference-graphic" />;
    }
    if (index === 0) {
      return <img src={aboutDesignSystemsImg} alt="Enterprise Design Systems 3D Isometric Visual" className="img-fluid skills-reference-graphic" />;
    }
    if (index === 1) {
      return <img src={aboutDesignEngineeringImg} alt="Development Knowledge 3D Isometric Visual" className="img-fluid skills-reference-graphic" />;
    }
    if (index === 2) {
      return <img src={aboutAmbiguityClarityImg} alt="Collaboration & Leadership 3D Isometric Visual" className="img-fluid skills-reference-graphic" />;
    }
    return <img src={aboutEnterprisePlatformImg} alt="Enterprise Platforms 3D Isometric Visual" className="img-fluid skills-reference-graphic" />;
  };

  return (
    <section id="skills" className="skills-container py-4">
      <div className="container">
        {/* Section Title */}
        <h2 className="skills-title text-start mb-3">My Skills</h2>

        {skillsList.map((category, index) => {
          const isEven = index % 2 === 1; // Alternating layout
          const visualCol = (
            <div key="vis" className={`col-12 col-md-6 ${isEven ? '' : 'order-1 order-md-2'} text-center mb-4 mb-md-0`}>
              <div className={`skills-visual-${(index % 3) + 1}`}>
                {renderVisual(index, category.media)}
              </div>
            </div>
          );

          const textCol = (
            <div key="txt" className={`col-11 col-md-6 ${isEven ? '' : 'order-2 order-md-1'} skills-item skills-item--${(index % 3) + 1} mx-auto text-start`}>
              <h3 className="skills-heading mb-4 d-flex align-items-center gap-2">
                {renderSkillCategoryIcon(category.icon, category.title)}
                <span>{category.title}</span>
              </h3>

              {category.skills && category.skills.length > 0 ? (
                <div className="skills-sublist">
                  {category.skills.map((sub, sIdx) => (
                    <div key={sIdx} className="skills-subitem mb-4">
                      <h5 className="skills-subitem-title">{sub.title}</h5>
                      <p className="skills-subitem-desc mb-0">{sub.description}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p>{category.summary}</p>
              )}
            </div>
          );

          return (
            <div key={category.id || index} className="row mb-5 py-4 align-items-center">
              {isEven ? (
                <>
                  {visualCol}
                  {textCol}
                </>
              ) : (
                <>
                  {textCol}
                  {visualCol}
                </>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Skills;